<template>
  <v-container fluid class="px-1 py-1">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body>
        <v-sheet class="px-3 py-3">
          <BaseFieldString
              v-model="storeAggregate.rootData[storeDetail.uidItem].part_number"
              label="P/N"
              class="mt-3"
          ></BaseFieldString>
          <CommonPartialSelectFromTable
              v-model="storeAggregate.rootData[storeDetail.uidItem].provider_uid"
              label="Provider"
              dto-list-query="ProviderListQueryDTO"
              store-name="SelectProvider"
              :sort-by="['name']"
              class="mt-3"
          >
          </CommonPartialSelectFromTable>
          <CommonPartialSelectFromTable
                  v-model="storeAggregate.rootData[storeDetail.uidItem].component_uid"
                  dto-list-query="ComponentShortListQueryDTO"
                  store-name="SelectComponent"
                  :sort-by="['article_display', 'alias']"
                  item-text="alias_article"
                  :label="$t('manual_mpn')"
                  class="mt-3"
              >
              </CommonPartialSelectFromTable>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";
import CommonPartialSelectFromTable from "@/components/Common/CommonPartialSelectFromTable";

export default {
  name: "ProviderComponentDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'ProviderComponentDetail'},
    dtoDetailQuery: {default: 'ProviderComponentDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'ProviderComponentActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'ProviderComponentSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'ProviderComponentValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'ProviderComponentBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'ProviderComponentTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    BaseFieldString,
    CommonDetail,
    CommonPartialSelectFromTable,
  },

  computed: {},

  methods: {}
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
    }
  }
  ,
}
</script>

<style scoped>

</style>